import { ColocaStatusPill } from "@/shared/components/data-display/ColocaStatusPill";
import useTranslations from "@/shared/lang/useTranslations";
import { cn } from "@/shared/lib/utils";

import { BATCH_STATUS_LABEL_KEYS, BATCH_STATUS_PILL } from "../../constants/payoutBatches.constants";
import type { PayoutBatchStatus } from "../../types/payoutBatches.types";
import { isLiveStatus } from "../../utils/batchStatus";

export interface BatchStatusPillProps {
  status: PayoutBatchStatus;
  size?: "default" | "sm";
  className?: string;
}

/** Batch lifecycle pill; the dot pulses while the batch is still moving on its own. */
export function BatchStatusPill({ status, size, className }: BatchStatusPillProps) {
  const { t } = useTranslations("payoutBatches");
  const live = isLiveStatus(status);
  return (
    <ColocaStatusPill
      variant={BATCH_STATUS_PILL[status] ?? "neutral"}
      size={size}
      withDot
      className={cn(live && "[&>span:first-child]:animate-pulse", className)}
    >
      {BATCH_STATUS_LABEL_KEYS[status] ? t(BATCH_STATUS_LABEL_KEYS[status]) : status}
    </ColocaStatusPill>
  );
}
